import { render, staticRenderFns } from "./NewTaskDialog.vue?vue&type=template&id=426c7cb0"
import script from "./NewTaskDialog.vue?vue&type=script&lang=js"
export * from "./NewTaskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports